var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "user_profile bg-gradient-primary bd-callout bd-callout-success position-relative mt-2 px-2 p-1",
      class: { "cursor-pointer": _vm.show_select },
      on: { click: _vm.push_in_select },
    },
    [
      _c(
        "div",
        { staticClass: "d-flex flex-row pt-2 pb-1", class: _vm.checked_item },
        [
          _c("span", { staticClass: "status" }, [
            _vm.obj_to_null(_vm.product_image)
              ? _c("img", {
                  staticClass: "profile-image rounded-circle d-inline-block",
                  attrs: { src: _vm.product_image },
                })
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm.show_remove
            ? _c(
                "span",
                {
                  staticClass: "position-absolute pos-right pr-3 remove",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.remove_item.apply(null, arguments)
                    },
                  },
                },
                [_vm._m(0)]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "user_attrib ml-3" }, [
            _c("div", { staticClass: "name d-block fw-700 text-dark" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.product_title) +
                  "\n            "
              ),
            ]),
            _vm._v(" "),
            _vm.product.hasOwnProperty("main_categ")
              ? _c(
                  "div",
                  {
                    staticClass: "company small text-dark badge badge-success",
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.product.main_categ.title) +
                        "\n            "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "company small text-dark" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.product.uniq_id) +
                  "\n            "
              ),
            ]),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticClass: "btn btn-danger btn-sm btn-icon waves-effect waves-themed",
      },
      [_c("i", { staticClass: "fal fa-times" })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }